import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  TableCaption,
  Thead,
  Tbody,
  Button,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Image,
  Box,
  Text,
  Tfoot,
} from "@chakra-ui/react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaEdit, FaTrash } from "react-icons/fa";
import UpdateRoomBookModal from "./updateRoomBookModal";
import toast from "react-hot-toast";
import ForeignReportModal from "./foreignReportModal";
import Cookie from "js-cookie";
import RoomBookPrintModal from "./roomBookPrintModal";
import { useLocation } from "react-router-dom";
import LedgerPrintModal from "./ledgerPrintModal";
import { use } from "react";

const CustomerLedger = () => {
  const [data, setData] = useState([]);
  const [roomBill, setRoomBill] = useState([]);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [printData, setPrintData] = useState([]);
  const [payment, setPayment] = useState({});
  const location = useLocation();
  const { registration, phoneNo } = location.state || {};
  const [ledgerData, setLedgerData] = useState([]);
  const token = Cookie.get("token");
  const [customerData, setCustomerData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [roomBook, setRoomBookData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cashData, setCashData] = useState([]);
  const [formData, setFormData] = useState({
    registration: registration ? registration : "",
    phoneNo: phoneNo ? phoneNo : "",
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [searchTerm, setSearchTerm] = useState("");

  const [isOpen1, setIsOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const {
    isOpen: isPrintOpen,
    onOpen: onPrintOpen,
    onClose: onPrintClose,
  } = useDisclosure();
  //const [toggle,setToggle]=useState(false)
  const customerId = localStorage.getItem("customerId");
  const fetchRoomBillData = async () => {
    const response = await axios.get(
      `https://api.hotel.launchlysoftware.in/api/getRoomBilldata/${customerId}`,
    );
    setRoomBill(response.data);
  };

  const fetchData = async () => {
    const response = await axios.get(
      `https://api.hotel.launchlysoftware.in/api/customerLedger/${customerId}?registration=${formData.registration}&phoneNo=${formData.phoneNo}`,
    );
    setData(response.data.dailyData);
    setCustomerData(response.data.ledger[0]);
    setLedgerData(response.data.ledger);
    setPayment(response.data.totalData);
    setCashData(response.data.cashBillData);
    setFilteredData(response.data.dailyData); // Initialize filteredData with all data
  };
  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.hotel.launchlysoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );

      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (formData.registration || formData.phoneNo) {
      fetchData();
    }
  }, [customerId]);
  useEffect(() => {
    fetchData3();
  }, [customerId]);

  // Function to handle search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filteredData(event.target.value);
  };
  const handlePrintModal = () => {
    onPrintOpen();
  };

  const exportToExcel = () => {
    const data = filteredData.map((item) => ({
      Name: item.name,
      Email: item.email,
      Nationality: item.nationality,
      Purpose: item.purpose,
      Registration: item.registration,
      Pax: item.pax,
      Adult: item.adult,
      Child: item.child,
      Date: item.date,
      ArrivedFrom: item.arrivedFrom,
      NextDestination: item.nextDestination,
      Address: item.address,
      PhoneNo: item.phoneNo,
      Adhar: item.adhar,
      VoterId: item.voterId,
      Passport: item.passport,
      GovernmentIssuedId: item.goverMentIssuedId,
      CheckIn: item.checkIn,
      CheckOut: item.checkOut,
      RoomNo: item.roomNo,
      Category: item.category,
      AC: item.ac,
      BookingBy: item.bookingBy,
      Stay: item.stay,
      Arrival: item.arrival,
      PlaceOfIssue: item.placeOfIssue,
      Visa: item.visa,
      IssueVisa: item.issueVisa,
      Expiry: item.expiry,
      Issue: item.issue,
      SingleRate: item.singleRate ? "Yes" : "No",
      WithBreakfast: item.withBreakfast ? "Yes" : "No",
      WithLunchDinner: item.withLunchDinner ? "Yes" : "No",
      WithBreakfastLunchDinner: item.withBreakfastLunchDinner ? "Yes" : "No",
      RoomOnly: item.roomOnly ? "Yes" : "No",
      ExtraPerson: item.extraPerson ? "Yes" : "No",

      // Images URLs
      ImageUrl: item.imageUrl,
      AdharUrl: item.adharUrl,
      DrivingUrl: item.drivingUrl,
      PanUrl: item.panUrl,
      VoterUrl: item.voterUrl,
      GovernmentUrl: item.govermentUrl,

      // File Names (if you want file name separately)
      AdharImage: item.adharImage,
      DrivingLicenseImage: item.drivingLicense,
      PanNoImage: item.panNo,
      VoterIdImage: item.voterIdImage,
      GovernmentIssuedIdImage: item.goverMentIssuedIdImage,

      // Other Guests Info
      OtherGuests: item.other
        ?.map(
          (guest, index) =>
            `Guest ${index + 1}: ${guest.name} (${guest.relation}) - ${guest.select}: ${guest.adharNo}-${guest.otherAdharUrl}`,
        )
        .join("; "),
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "RoomData");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(fileData, "RoomData.xlsx");
  };
  const getFormattedCurrentDate = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}${period.toLowerCase()}`;
    return [
      formattedDate,
      `${day}-${month}-${year}`,
      `${hours}:${minutes} ${period}`,
    ];
  };
  useEffect(() => {
    const [_, formattedDate, formattedTime] = getFormattedCurrentDate();
    setDate(formattedDate);
    setTime(formattedTime);
  }, [customerId]);

  // Function to filter data based on search term

  return (
    <div>
      <Box
        display="flex"
        mt={10}
        gap={2}
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <Input
          w="25%"
          type="text"
          name="registration"
          value={formData.registration}
          onChange={(e) => handleInputChange(e)}
          mb={4} // Adds margin bottom for spacing
        />
        <Input
          w="25%"
          type="text"
          name="phoneNo"
          value={formData.phoneNo}
          onChange={(e) => handleInputChange(e)}
          mb={4} // Adds margin bottom for spacing
        />

        <Button colorScheme="teal" mb={4} onClick={handlePrintModal}>
          Print
        </Button>
        <Button colorScheme="teal" mb={4} onClick={() => fetchData()}>
          Search
        </Button>
      </Box>
      <LedgerPrintModal
        customerId={customerId}
        isOpen={isPrintOpen}
        onClose={onPrintClose}
        date={date}
        time={time}
        onOpen={onPrintOpen}
        customerData={customerData}
        ledgerData={ledgerData}
        filteredData={filteredData}
        payment={payment}
      />

      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        width="full"
        p={5}
      >
        <Box width="full">
          <Text
            border="1px solid black"
            borderBottom="none"
            fontSize="xl"
            fontWeight="bold"
          >
            Tax Invoice
          </Text>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          width="full"
        >
          <Box border="1px solid black" p={10} width="120%" textAlign="left">
            <Text>Reservation ID - {customerData?.registration}</Text>
            <Text>Mode Of Payment - Cash Front Office</Text>
            {/* <Text mb={4}>Room No - {customerData?.roomNo} {customerData?.category}</Text> */}
            <Text mb={4}>
              Room No- {ledgerData?.map((i) => i.roomNo).join(" , ")}
            </Text>
            <Text>Guest Name - {customerData?.name} </Text>
            <Text>Address - {customerData?.address}</Text>
            <Text>Ph No - {customerData?.phoneNo} </Text>
            <Text>Email - {customerData?.email}</Text>
            <Text>Company - </Text>
            <Text>Gst In - </Text>
          </Box>
          <Box
            border="1px solid black"
            borderLeft="none"
            p={9}
            width="60%"
            textAlign="left"
          >
            <Text>Invoice No - </Text>
            <Text>
              Invoice Date - {date} {time}
            </Text>
            <Text>Arrival Date - {customerData?.checkIn} </Text>
            <Text>Departure Date - {customerData?.checkOut} </Text>
            <Text>GRC No - </Text>
            <Text>
              Bill Type - {date} {time}
            </Text>
            <Text>Pax - {customerData?.pax}</Text>
            <Text>Adult - {customerData?.adult}</Text>
            <Text>Child - {customerData?.child}</Text>
            <Text>
              Nights - {date} {time}
            </Text>
          </Box>
        </Box>
      </Box>

      <TableContainer width="full" p={5}>
        <Table size="sm" variant="striped" colorScheme="teal">
          <TableCaption>Customer Ledger</TableCaption>
          <Thead

          // Background color to avoid transparency when scrolling
          >
            <Tr>
              <Th border="1px solid" borderColor="gray.300">
                Date
              </Th>
              <Th border="1px solid" borderColor="gray.300">
                Description
              </Th>

              <Th border="1px solid" borderColor="gray.300">
                Debit
              </Th>
              <Th border="1px solid" borderColor="gray.300">
                Credit
              </Th>
              <Th border="1px solid" borderColor="gray.300">
                Balance
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredData?.map((item, index) => {
              return (
                <>
                  {item.roomCharge.map((room, i) => (
                    <React.Fragment key={`${index}-room-${i}`}>
                      <Tr>
                        <Td>{item.date}</Td>
                        <Td>
                          {room.roomNo} - {room.category}
                        </Td>
                        <Td>{room.roomRate}</Td>
                        <Td>0</Td>
                        <Td></Td>
                      </Tr>
                      <Tr>
                        <Td>{item.date}</Td>
                        <Td>SGST</Td>
                        <Td>{room.cgst}</Td>
                        <Td>0</Td>
                        <Td></Td>
                      </Tr>
                      <Tr>
                        <Td>{item.date}</Td>
                        <Td>CGST</Td>
                        <Td>{room.sgst}</Td>
                        <Td>0</Td>
                        <Td></Td>
                      </Tr>
                    </React.Fragment>
                  ))}
                  {/* These rows render once per item, after all rooms */}
                  <Tr key={`${index}-food`}>
                    <Td>{item.date}</Td>
                    <Td>FoodCharge</Td>
                    <Td>{item.foodCharge}</Td>
                    <Td>0</Td>
                    <Td></Td>
                  </Tr>

                  <Tr key={`${index}-service`}>
                    <Td>{item.date}</Td>
                    <Td>RoomService</Td>
                    <Td>{item.serviceCharge}</Td>
                    <Td>0</Td>
                    <Td></Td>
                  </Tr>
                  <Tr key={`${index}-cash`}>
                    <Td>{item.date}</Td>
                    <Td>Payment</Td>
                    <Td>0</Td>
                    <Td>{item.cashPaid}</Td>
                    <Td></Td>
                  </Tr>
                  <Tr mb={4} key={`${index}-due`}>
                    <Td>{item.date}</Td>
                    <Td fontWeight="lg">Day Total</Td>
                    <Td fontWeight="lg">
                      {item.roomFair + item.serviceCharge + item.foodCharge}
                    </Td>
                    <Td fontWeight="lg">{item.cashPaid}</Td>
                    <Td fontWeight="lg">{item.due}</Td>
                  </Tr>
                  {/* Spacer row */}
                  <Tr key={`${index}-spacer`}>
                    <Td colSpan={5} style={{ height: "50px", padding: 0 }}></Td>
                  </Tr>
                </>
              );
            })}
          </Tbody>
          <Tfoot>
            <Tr>
              <Td colSpan={2} fontWeight="lg">
                Grand Total
              </Td>
              <Td>
                {Number(payment.netRoomBill) +
                  Number(payment.serviceBilll) +
                  Number(payment.netFoodBill)}
              </Td>
              <Td>{payment.totalCash}</Td>
              <Td>
                {Number(payment.netRoomBill) +
                  Number(payment.serviceBilll) +
                  Number(payment.netFoodBill) -
                  Number(payment.totalCash)}
              </Td>
            </Tr>
          </Tfoot>
        </Table>
      </TableContainer>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        gap={2}
        p={5}
        width="full"
      >
        <Box width="40%" textAlign="left">
          <TableContainer>
            <Table size="sm" variant="striped" colorScheme="teal">
              <TableCaption>Tax Details</TableCaption>
              <Thead>
                <Tr>
                  <Td>TAX_NAME</Td>
                  <Td>TAXABLE AMOUNT</Td>
                  <Td>TAX</Td>
                </Tr>
                <Tr>
                  <Td>CGST 2.5%</Td>
                  <Td>{payment.taxableFoodBill}</Td>
                  <Td>{payment.foodTax}</Td>
                </Tr>
                <Tr>
                  <Td>CGST 2.5%</Td>
                  <Td>{payment.taxableFoodBill}</Td>
                  <Td>{payment.foodTax}</Td>
                </Tr>
                <Tr>
                  <Td>CGST 6%</Td>
                  <Td>{payment.taxableRoomBill}</Td>
                  <Td>{payment.roomBillTax}</Td>
                </Tr>{" "}
                <Tr>
                  <Td>CGST 6%</Td>
                  <Td>{payment.taxableRoomBill}</Td>
                  <Td>{payment.roomBillTax}</Td>
                </Tr>
              </Thead>
              <Tbody>
                <Tr></Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          width="40%"
          display="flex"
          flexDirection="row"
          textAlign="left"
          p={5}
        >
          <Box border="1px solid black" borderRight="None" p={3} width="40%">
            <Text>Gross Amount:</Text>
            <Text>Total Discount:</Text>
            <Text>Total Tax:</Text>
            <Text>Net Amount:</Text>
          </Box>
          <Box Box border="1px solid black" p={3} width="40%">
            <Text>
              {Number(payment.taxableRoomBill) +
                Number(payment.taxableFoodBill) +
                Number(payment.serviceBilll)}
            </Text>
            <Text>{Number(payment.discount)}</Text>
            <Text>{Number(payment.foodTax) + Number(payment.roomBillTax)}</Text>
            <Text>
              {Number(payment.netRoomBill) +
                Number(payment.serviceBilll) +
                Number(payment.netFoodBill)}
            </Text>
          </Box>
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        p={5}
        alignItems="left"
        width="full"
      >
        <Text borderTop="1px solid black">Guest Signature</Text>
        <Text borderTop="1px solid black">Authorized Signature</Text>
      </Box>
      <Box
        width="full"
        display="flex"
        flexDirection="row"
        justifyContent="start"
        alignItems="left"
        p={5}
      >
        <Box width="40%" textAlign="left" p={3}>
          {printData.map((item) => (
            <>
              <Text>A/C NO - {item.acNo}</Text>
              <Text>IFSC CODE - {item.ifsc}</Text>
              <Text>BRANCH - {item.branch}</Text>
              <Text>CONTACT NO - {item.phoneNo}</Text>
            </>
          ))}
        </Box>
        <Box
          width="60%"
          display="flex"
          flexDirection="row"
          justifyContent="end"
          alignItems="right"
          textAlign="left"
          pt={5}
          pr={35}
        >
          <TableContainer>
            <Table size="sm" variant="simple" colorScheme="teal">
              <TableCaption>STATEMENT</TableCaption>
              <Thead>
                <Tr>
                  <Td>PARTICULARS</Td>
                  <Td>PAID AMOUNT</Td>
                  <Td>BILL AMOUNT</Td>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>ROOM AMOUNT</Td>
                  <Td>{payment.netRoomBill}</Td>
                  <Td>0</Td>
                </Tr>
                <Tr>
                  <Td>FOOD AMOUNT</Td>
                  <Td>{payment.netFoodBill}</Td>
                  <Td>0</Td>
                </Tr>

                <Tr>
                  <Td>OTHER AMOUNT</Td>
                  <Td>{payment.serviceBilll}</Td>
                  <Td>0</Td>
                </Tr>
                <Tr>
                  <Td>ONLINE</Td>
                  <Td>0</Td>
                  <Td>{payment.onlyOnline}</Td>
                </Tr>
                <Tr>
                  <Td>CARD</Td>
                  <Td>0</Td>
                  <Td>{payment.onlyCard}</Td>
                </Tr>
                <Tr>
                  <Td>CASH</Td>
                  <Td>0</Td>
                  <Td>{payment.onlyCash}</Td>
                </Tr>
              </Tbody>
              <Tfoot>
                <Tr>
                  <Td></Td>
                  <Td>
                    {Number(payment.netRoomBill) +
                      Number(payment.serviceBilll) +
                      Number(payment.netFoodBill)}
                  </Td>
                  <Td>{Number(payment.totalCash)}</Td>
                </Tr>
                <Tr>
                  <Td colSpan={2}>Payable Amount</Td>
                  <Td>
                    {Number(payment.netRoomBill) +
                      Number(payment.serviceBilll) +
                      Number(payment.netFoodBill) -
                      (Number(payment.totalCash) + Number(payment.discount))}
                  </Td>
                </Tr>
              </Tfoot>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </div>
  );
};

export default CustomerLedger;
